import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { eadmissionAPI } from '../../apis';
import { useGetUserInfo } from '..';

const useCheckServer = (ctrl) => {
  const userInfo = useGetUserInfo();

  const check = async () => {
    try {
      const { statusCode, statusMessage } = await eadmissionAPI.checkServer({ modules }, { isHideLoading: true });
      if (statusCode !== '0') {
        alertMsg(statusMessage);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userInfo.hospId && ctrl) {
      check();
      const interval = setInterval(() => {
        check();
      }, 15 * 60 * 1000);

      return () => clearInterval(interval);
    }
  }, [userInfo.hospId, ctrl]);
};

const modules = ['EAED', 'IPAS', 'CC_BUSSTOP', 'CC_MDRO', 'CC_COVID', 'CC_BEDSTATUS', 'MDRO', 'CMSMPL', 'WP_DB'];

const alertMsg = (msg, ID, type = 'error', timeout = null, autoClose = true) => {
  const alertEl = document.createElement('div');
  alertEl.setAttribute('id', ID);
  document.getElementById('root').appendChild(alertEl);
  ReactDOM.render(
    <Snackbar
      open={true}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={() => {
        autoClose && closeAlert(ID);
      }}
      autoHideDuration={timeout}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={() => {
          closeAlert(ID);
        }}
        severity={type}
      >
        <div dangerouslySetInnerHTML={{ __html: msg }} />
      </MuiAlert>
    </Snackbar>,
    alertEl
  );
};

const closeAlert = (ID) => {
  const targetEl = document.getElementById(ID);
  targetEl?.remove();
};

export default useCheckServer;
